import React from 'react';

export const Logo: React.FC = () => {
    return (
        <svg width='216' height='32' viewBox='0 0 216 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <defs>
                <clipPath id='clip2458_157392'>
                    <rect id='T1 nota main' width='216' height='32' fill='white' fillOpacity='0' />
                </clipPath>
            </defs>
            <g clipPath='url(#clip2458_157392)'>
                <path
                    id='path'
                    d='M17.19 13.67L0.03 13.67L0.03 8.05L1.68 8.05L1.68 12.02L15.54 12.02L15.54 8.05L17.19 8.05L17.19 13.67Z'
                    fill='#1D1D1B'
                    fillOpacity='1'
                    fillRule='nonzero'
                />
                <path
                    id='path'
                    d='M17.19 24.2L15.54 24.2L15.54 20.23L1.68 20.23L1.68 24.2L0.03 24.2L0.03 18.58L17.19 18.58L17.19 24.2Z'
                    fill='#1D1D1B'
                    fillOpacity='1'
                    fillRule='nonzero'
                />
                <path
                    id='path'
                    d='M38.86 13.66C39.87 10.97 42.46 9.06 45.49 9.06C48.51 9.06 51.11 10.97 52.11 13.66L53.85 13.66C52.77 10.05 49.43 7.43 45.49 7.43C41.54 7.43 38.2 10.07 37.12 13.66L38.86 13.66Z'
                    fill='#1D1D1B'
                    fillOpacity='1'
                    fillRule='nonzero'
                />
                <path
                    id='path'
                    d='M52.14 18.59C51.15 21.3 48.54 23.25 45.48 23.25C42.43 23.25 39.82 21.32 38.83 18.59L37.1 18.59C38.17 22.22 41.52 24.89 45.48 24.89C49.44 24.89 52.82 22.22 53.86 18.59L52.14 18.59Z'
                    fill='#1D1D1B'
                    fillOpacity='1'
                    fillRule='nonzero'
                />
                <path
                    id='path'
                    d='M104.44 13.66C105.44 10.97 108.04 9.05 111.08 9.05C114.12 9.05 116.7 10.97 117.72 13.66L119.49 13.66L119.49 8.09L117.84 8.09L117.84 10.79C116.36 8.72 113.81 7.41 111.08 7.41C107.14 7.41 103.79 10.05 102.72 13.66L104.44 13.66Z'
                    fill='#1D1D1B'
                    fillOpacity='1'
                    fillRule='nonzero'
                />
                <path
                    id='path'
                    d='M119.46 18.59L117.74 18.59C116.73 21.3 114.14 23.24 111.08 23.24C108.02 23.24 105.43 21.3 104.43 18.59L102.7 18.59C103.77 22.22 107.12 24.87 111.08 24.87C115.04 24.87 116.42 23.53 117.84 21.53L117.84 24.2L119.49 24.2L119.49 18.59L119.46 18.59Z'
                    fill='#1D1D1B'
                    fillOpacity='1'
                    fillRule='nonzero'
                />
                <path
                    id='path'
                    d='M86.57 8.15L70.88 8.15L70.88 9.8L86.57 9.8L86.57 8.15Z'
                    fill='#1D1D1B'
                    fillOpacity='1'
                    fillRule='nonzero'
                />
                <path
                    id='path'
                    d='M79.55 13.64L77.9 13.64L77.9 24.2L79.55 24.2L79.55 13.64Z'
                    fill='#1D1D1B'
                    fillOpacity='1'
                    fillRule='nonzero'
                />
                <line
                    id='line'
                    x1='143.582031'
                    y1='3.287109'
                    x2='143.582031'
                    y2='29.026367'
                    stroke='#0C0D0D'
                    strokeOpacity='1'
                    strokeWidth='0.258254'
                />
                <path
                    id='path'
                    d='M209.14 10.53L197.93 10.53L197.93 13.02L202.29 13.02L202.29 21.8L204.77 21.8L204.77 13.02L209.13 13.02L209.14 10.53Z'
                    fill='#1D1D1B'
                    fillOpacity='1'
                    fillRule='nonzero'
                />
                <path
                    id='path'
                    d='M214.05 10.48L211.48 10.48L211.48 21.76L214.05 21.76L214.05 10.48Z'
                    fill='#1D1D1B'
                    fillOpacity='1'
                    fillRule='nonzero'
                />
                <path
                    id='path'
                    d='M177.71 14.26L185.14 14.26L185.14 18.06L177.71 18.06L177.71 25.53L173.92 25.53L173.92 18.06L166.49 18.06L166.49 14.26L173.92 14.26L173.92 6.78L177.71 6.78L177.71 14.26ZM188.92 6.77L188.92 25.53L192.7 25.53L192.7 6.77L188.92 6.77Z'
                    fill='#1D1D1B'
                    fillOpacity='1'
                    fillRule='nonzero'
                />
            </g>
        </svg>
    );
};
